// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
    max-width: 700px;
    width: 900px;
    margin: 40px auto;
    padding: 0px 20px 20px 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #031E3C;
    text-align: start;
  }

  .title2 {
    font-size: 15px;
    font-weight: 400;
    color: #3F4B5B;
    text-align: start;
  }

  .form-container h2 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  
  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;
  }
  
  .form-grid input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
  }
  
  .file-upload {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
    margin-bottom: 5px;
  }

  .error-message{
    text-align: start;
    font-size: 12px;
    color: red;

  }
  
  .file-upload:hover {
    border-color: #888;
  }
  
  .file-upload input {
    display: none;
  }
  
  .file-upload label {
    display: block;
    cursor: pointer;
    font-size: 14px;
    color: #333;
  }
  
  .file-upload p {
    font-size: 13px;
    color: #888;
    margin-top: 4px;
  }
  
  .checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 20px;
  }

  .checkbox-input {
    margin-top: 17px;
  }
  
  .checkbox p {
    text-align: start;
    font-size: 15px;
    color: #555;
    line-height: 1.4;
  }
  
  .submit-btn {
    background: #e53935;
    color: #fff;
    padding: 10px 24px;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
    transition: background 0.3s;
  }
  
  .submit-btn:hover {
    background: #c62828;
  }
  .Toastify__toast-body {
    font-size: 14px; /* Энд хүссэн хэмжээ */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/style/recruitmentForm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;EACvC;;;EAGA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,UAAU;;EAEZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe,EAAE,sBAAsB;EACzC","sourcesContent":[".form-container {\n    max-width: 700px;\n    width: 900px;\n    margin: 40px auto;\n    padding: 0px 20px 20px 20px;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  }\n  \n\n  .title {\n    font-size: 20px;\n    font-weight: bold;\n    color: #031E3C;\n    text-align: start;\n  }\n\n  .title2 {\n    font-size: 15px;\n    font-weight: 400;\n    color: #3F4B5B;\n    text-align: start;\n  }\n\n  .form-container h2 {\n    font-size: 20px;\n    font-weight: 500;\n    margin-bottom: 20px;\n  }\n  \n  .form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 15px;\n    margin-bottom: 20px;\n  }\n  \n  .form-grid input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    font-size: 14px;\n  }\n  \n  .file-upload {\n    border: 2px dashed #ccc;\n    border-radius: 8px;\n    padding: 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: border-color 0.3s;\n    margin-bottom: 5px;\n  }\n\n  .error-message{\n    text-align: start;\n    font-size: 12px;\n    color: red;\n\n  }\n  \n  .file-upload:hover {\n    border-color: #888;\n  }\n  \n  .file-upload input {\n    display: none;\n  }\n  \n  .file-upload label {\n    display: block;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n  }\n  \n  .file-upload p {\n    font-size: 13px;\n    color: #888;\n    margin-top: 4px;\n  }\n  \n  .checkbox {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n\n  .checkbox-input {\n    margin-top: 17px;\n  }\n  \n  .checkbox p {\n    text-align: start;\n    font-size: 15px;\n    color: #555;\n    line-height: 1.4;\n  }\n  \n  .submit-btn {\n    background: #e53935;\n    color: #fff;\n    padding: 10px 24px;\n    border: none;\n    border-radius: 8px;\n    font-size: 15px;\n    cursor: pointer;\n    transition: background 0.3s;\n  }\n  \n  .submit-btn:hover {\n    background: #c62828;\n  }\n  .Toastify__toast-body {\n    font-size: 14px; /* Энд хүссэн хэмжээ */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
